import { useEffect, useMemo, useState } from "react";

export const useIsInViewport = (element: HTMLElement | null) => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const observer = useMemo(() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)), []);

    useEffect(() => {
        if (element) {
            observer.observe(element);
        }

        return () => {
            observer.disconnect();
        };
    }, [element, observer]);

    return isIntersecting;
};
